import { isObject } from "lodash";

export const parseEndPointFlags = (str) => {
  try {
    if (isObject(JSON.parse(str))) return JSON.parse(str);
    return {};
  } catch (error) {
    return {};
  }
};

export const parseUser = (str) => {
  try {
    if (isObject(JSON.parse(str))) return JSON.parse(str);
    return {};
  } catch (error) {
    return {};
  }
};

export const parseTheme = (str) => {
  try {
    let theme = {
      mode: "dark",
      color: "white",
    };
    if (isObject(JSON.parse(str))) {
      theme = JSON.parse(str);
    }
    return theme;
  } catch (error) {
    return {
      mode: "dark",
      color: "white",
    };
  }
};

export const parseColor = (str) => {
  try {
    return JSON.parse(str);
  } catch (error) {
    return {};
  }
};

export const parseMapping = (obj) => {
  try {
    return JSON.parse(obj);
  } catch (error) {
    return {};
  }
};
export const parseLocalStorageObj = (obj) => {
  try {
    return JSON.parse(localStorage.getItem(obj));
  } catch (error) {
    return {};
  }
};
export const stringhfyLocalStorageObj = (name, obj) => {
  try {
    localStorage.setItem(name, JSON.stringify(obj));
  } catch (error) {
    console.log(error);
  }
};
export const stringhfySessionStorageObj = (name, obj) => {
  try {
    sessionStorage.setItem(name, JSON.stringify(obj));
  } catch (error) {
    console.log(error);
  }
};
